import { useState, useCallback } from 'react';

export const useImageLoader = () => {
  const [hasImageError, setHasImageError] = useState(false);
  const handleImageError = useCallback(() => setHasImageError(true), []);

  return { hasImageError, handleImageError };
};
